import GoogleAnalyticsService from '../../common/services/analytics/google-analytics.service';
import { MasterCard, PaymentMethod } from '../services/payment-method.model';
import { Payment } from '../../common/services/package/package.model';
import PackageService from '../../common/services/package/package.service';

import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';
import { PaycellService } from '../services/paycell.service';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { CardDeleteAction } from '../card-delete-dialog/card-delete-dialog.action';
import { CardDeleteSuccessAction } from '../card-delete-success-dialog/card-delete-success-dialog.action';
import UtilService from '../../common/services/util.service';
import { MasterpassService } from '../services/masterpass.service';
import UserService from '../../common/services/user/user.service';
import {MasterpassCardDeleteAction} from '../masterpass-card-delete-dialog/masterpass-card-delete-dialog.action';
import '../../../assets/img/credit-card-logo.png';
/* @ngInject */
export default class SavedCardsController {
  private subscribeCardMessage: string;
  public cards: PaymentMethod[] = [];
  public activeCard: PaymentMethod;
  public payments: Payment[] = [];
  private logoMap:any;
  private msisdnTr:string;
  public masterCards: MasterCard[] = [];
  private masterTokenRefreshCount:number = 0;

  constructor(
    private paycellService: PaycellService,
    private globalSpinner: GlobalSpinnerService,
    private actionDispatcher: ActionDispatcherService,
    private packageService: PackageService,
    private $translate,
    private googleAnalytics: GoogleAnalyticsService,
    private $rootScope,
    private masterpassService: MasterpassService,
    private userService: UserService,
    private config,
    private i18n
  ) {
    this.globalSpinner.start();
    this.paycellService
      .getCards()
      .then(cards => {
        this.cards = cards;
        if(this.cards){
          this.cards = this.cards.sort((a,b)=> (a.isDefault === b.isDefault)? 0 : a.isDefault? -1 : 1)
        }
        this.getPayments(cards);
        this.activeCard = UtilService.getElements(this.cards, data =>
          this.comparator(data)
        )[0];

        if (angular.isUndefined(this.activeCard)) {
          this.activeCard = this.cards[0];
        }
      })
      .catch((/*error*/) => (this.cards = []))
      .finally(() => this.globalSpinner.stop());
      window['MFS'].setClientId(this.config.masterpass.clientId);
      if(!!this.config.masterpass.address) {
        window['MFS'].setAddress(this.config.masterpass.address);
      }
      this.logoMap = this.config.masterpass.logoMap;
  }

  public getPayments(cards: PaymentMethod[]) {
    cards.map(card => {
      card.userListeningPackages = [];
      this.paycellService
        .getPaymentMethod(card.paymentMethodID, card.cardId)
        .then(paymentMethods => {
          paymentMethods.userListeningPackages.map(x => {
            card.userListeningPackages.push(x.listeningPackage.name);
          });
        });
    });
  }

  public getMasterPayments() {
    this.masterCards.map(card => {
      card.userListeningPackages = [];
      this.masterpassService
        .getPaymentMethod(card.Name, card.UniqueId)
        .then(paymentMethods => {
          paymentMethods.userListeningPackages.map(x => {
            card.userListeningPackages.push(x.listeningPackage.name);
          });
        });
    });
  }
  public $onInit() {
    this.loadTranslations();
    var _self = this;
    this.$rootScope.$on('$translateChangeSuccess', function (event, a) {
      _self.loadTranslations();
    });

    this.googleAnalytics.writeVirtualPages({
      event: 'GAVirtual',
      virtualPageTitle: 'Kayitli Kredi Kartlarim',
      virtualPageURL: '/saved-cards'
    });
    if(!!this.msisdnTr) {
      this.checkMasterPass();
    } else{
      this.userService.getUserInfo().then(data => {
        this.msisdnTr = '90' + data.msisdn;
        this.checkMasterPass();
      });
    }
  }

  public onDeleteCard(card: PaymentMethod) {
    this.activeCard = card;
    this.actionDispatcher.dispatch(
      new CardDeleteAction(
        paymentMethodID => this.onDeleteSuccess(paymentMethodID, card.cardId),
        card
      )
    );
  }

  public onDeleteMasterCard(card:MasterCard){
    this.actionDispatcher.dispatch(
      new MasterpassCardDeleteAction(
        cardName => this.onMasterpassDeleteSuccess(cardName),
        card,
        this.msisdnTr
      )
    )
  }

  public loadTranslations() {
    this.$translate('subscribed.card.message').then(value => {
      this.subscribeCardMessage = value;
    });
  }

  public getSubscribedMessage(pm?: string ) {
    return this.subscribeCardMessage.replace('{replace}', (pm||''));
  }

  private onDeleteSuccess(paymentMethodID: number, cardId: string): any {
    this.actionDispatcher.dispatch(new CardDeleteSuccessAction());
    this.cards = this.cards.filter(
      card => card.paymentMethodID != paymentMethodID || card.cardId != cardId
    );
    this.activeCard = this.cards[0];
  }

  private onMasterpassDeleteSuccess(cardName: string): any {
    this.actionDispatcher.dispatch(new CardDeleteSuccessAction());
    this.masterCards = this.masterCards.filter(
      card => card.Name != cardName
    );
  }

  private comparator(element: any): boolean {
    return element.isDefault == true;
  }

  public checkMasterPass(){
    this.masterpassService.isV2().then(isV2 => {
      if (isV2) {
        this.checkMasterPassV2();
        return;
      }

      this.checkMasterPassV1();
    });
  }

  private checkMasterPassV1(){
    $('[name=referenceNo]').val(UtilService.generateRandomNumber(999999999999));
    $('[name=userId]').val(this.msisdnTr);
    $('[name=sendSmsLanguage]').val(this.i18n.getCurrentLanguage() == 'en' ? 'eng' : 'tur');
    const masterToken = UtilService.getSessionStorageWithExpire("masterpass.token");
    if(!!masterToken) {
        $('[name=token]').val(masterToken);
        window['MFS'].checkMasterPass($('#checkMP-form'), this.chkMPResponseHandler.bind(this));
    } else {
      this.masterpassService.getToken().then(token => {
        UtilService.setSessionStorageWithExpire("masterpass.token", token, 840000);
        $('[name=token]').val(token);
        window['MFS'].checkMasterPass($('#checkMP-form'), this.chkMPResponseHandler.bind(this));
      });
    }
  }

  private chkMPResponseHandler(status, response) {
		if (response.responseCode == "0000" || response.responseCode == "") {
      if (response.accountStatus.indexOf("011100") == 0){
        this.listMasterCards();
      }
		} else if(this.config.masterpass.tokenRefreshErrorCodes.indexOf(response.responseCode) >= 0 && this.masterTokenRefreshCount < 5){
      sessionStorage.removeItem("masterpass.token");
      this.checkMasterPass();
      this.masterTokenRefreshCount++;
    } else {
			console.log(response.responseDescription);
		}
	}

  private checkMasterPassV2() {
    this.masterpassService.accountAccess(this.msisdnTr)
      .then(response => this.accountAccessResponseHandler(response))
      .catch(error => this.accountAccessResponseHandler(error));
  }

  private accountAccessResponseHandler(response: any) {
    const exceptionCode = response && response.exception ? response.exception.code : null;
    if (exceptionCode === 'ACCOUNT_NOT_FOUND' || exceptionCode === 'ACCOUNT_NOT_LINKED_TO_MERCHANT') {
      this.globalSpinner.stop();
      return;
    }

    if (response && response.result) {
      this.listCardsResponseHandler(null, {
        responseCode: '',
        cards: response.result.cards
      });
      return;
    }

    console.log(response && response.exception ? response.exception.message : null);
    this.globalSpinner.stop();
  }

  public listMasterCards(){
    this.masterpassService.isV2().then(isV2 => {
      if (isV2) {
        this.listMasterCardsV2();
        return;
      }

      this.listMasterCardsV1();
    });
  }

  private listMasterCardsV1(){
    const masterToken = UtilService.getSessionStorageWithExpire("masterpass.token");
    if(!!masterToken) {
        window['MFS'].listCards(this.msisdnTr, masterToken, this.listCardsResponseHandler.bind(this));
    } else {
      this.masterpassService.getToken().then(token => {
        UtilService.setSessionStorageWithExpire("masterpass.token", token, 840000);
        window['MFS'].listCards(this.msisdnTr, token, this.listCardsResponseHandler.bind(this));
      });
    }
  }

  private listMasterCardsV2() {
    this.masterpassService.accountAccess(this.msisdnTr)
      .then(response => this.accountAccessResponseHandler(response))
      .catch(error => this.accountAccessResponseHandler(error));
  }


  private listCardsResponseHandler(statusCode, response)
	{
		if (response.responseCode != "0000" && response.responseCode != "") {
			console.log(response.responseDescription);
			return;
		}

		this.masterCards =  response.cards;
    this.getMasterPayments()
    this.globalSpinner.stop();
	}

  public getMasterPassCardLogoonError(card: MasterCard){
    return card.Value1.startsWith('4') ? '/assets/img/visa@2x.png' : (card.Value1.startsWith('5') ? '/assets/img/credit-card-logo.png' : '');
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/saved-cards/saved-cards.controller.ts